var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-h6 font-weight-regular mb-2"},[_vm._t("default")],2),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }